import React, { Component, createContext } from "react";
import { getTopCompanies } from "../../services/api-company";
import { Link } from "@/helpers/router";
import { isArray } from "lodash";

const DEFAULT_COMPANIES = [
  "apple inc",
  "google llc",
  "samsung",
  "samsung electronics america, inc.",
  "samsung electronics co., ltd",
  "intel corporation",
  "microsoft corporation",
  "unified patents llc",
  "cisco systems, inc.",
  "lg electronics, inc.",
];

const CompaniesContext = createContext(DEFAULT_COMPANIES);

class TopCompaniesProvider extends Component {
  state = {
    companies: DEFAULT_COMPANIES,
    loading: false,
  }

  componentDidMount() {
    this._isMounted = true;
    this.setState({ loading: true });
    getTopCompanies()
      .then(companies => {
        if (this._isMounted) this.setState({
          companies,
          loading: false
        });
      })
      .catch(() => {
        if (this._isMounted) this.setState({
          companies: DEFAULT_COMPANIES,
          loading: false
        });
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return <CompaniesContext.Provider value={this.state.companies}>{this.props.children}</CompaniesContext.Provider>;
  }
}

const withTopCompanies = WrappedComponent => {
  const ComponentWithTopCompanies = props => {
    const companies = React.useContext(CompaniesContext);
    const companyRenderer = str => str && companies.includes(str.toLowerCase()) ? <Link to={`/company/${str}`}>{str}</Link> : str;
    const companiesRenderer = val => isArray(val) && val.length
      ? val.map((v, i) => (
        <p style={{ margin: 0 }} key={i}>
          {companyRenderer(v)}
        </p>
      ))
      : val;
    const newProps = {
      ...props,
      companies,
      companyRenderer,
      companiesRenderer
    };
    return <WrappedComponent {...newProps} />;
  };

  return ComponentWithTopCompanies;
};

export { TopCompaniesProvider, withTopCompanies };
